/* eslint func-names: "off" */

import axios from 'axios';
import store from '../../store';

let baseURL = window.location.origin;

if (process.env.PROXY_SERVER_URL) {
  baseURL = process.env.PROXY_SERVER_URL;
}

// Add a response interceptor
axios.interceptors.response.use(response => response, async (error) => {
  if (error.response.status === 401) {
    await store.dispatch('destoryCurrentUser');
    window.location.href = `${baseURL}/accounts/byteark`;
  }
  return Promise.reject(error);
});

export default axios;



// WEBPACK FOOTER //
// ./src/modules/axios/index.js